import { Checkbox, Box, IconButton } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { UserDevices } from "../../../app/services/api/types";

interface TreeDeviceProps {
  device: UserDevices;
  selected: number[];
  setSelected: (ids: number[]) => void;
  level?: number;
}

export const TreeDevice: React.FC<TreeDeviceProps> = ({
  device,
  selected,
  setSelected,
  level = 0
}) => {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = device.children && device.children.length > 0;
  const isSelected = selected.includes(device.id);

  const toggleSelect = () => {
    if (isSelected) {
      setSelected(selected.filter(id => id !== device.id));
    } else {
      setSelected([...selected, device.id]);
    }
  };

  return (
    <Box pl={level * 4}>
      <Box display="flex" alignItems="center" gap={1}>
        {hasChildren && (
          <IconButton
            variant="ghost"
            size="xs"
            icon={expanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            aria-label="Toggle expand"
            onClick={() => setExpanded(!expanded)}
          />
        )}
        {!hasChildren && <Box w="24px" />} {/* Placeholder for alignment */}
        <Checkbox isChecked={isSelected} onChange={toggleSelect}>
          {device.title}
        </Checkbox>
      </Box>

      {expanded &&
        hasChildren &&
        device.children!.map(child => (
          <TreeDevice
            key={child.id}
            device={child}
            selected={selected}
            setSelected={setSelected}
            level={level + 1}
          />
        ))}
    </Box>
  );
};